import './functions/bxslider';
import AOS from 'aos';
import colorbox from 'jquery-colorbox';

require('./polyfills/find-polyfill');

// Extend Jquery with simple toggleText function - used for More/Less buttons
$.fn.extend({
    toggleText: function(a, b){
        return this.text(this.text() == b ? a : b);
    }
});

// Extend jquery check if div is in viewport
$.fn.isOnScreen = function(){
    var win = $(window);

    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};


$(window).on('load', function () {
    $('body').addClass('loaded');
});

let scrollRef = 0;
  $(window).on("resize scroll", function () {
    // increase value up to 10, then refresh AOS
    scrollRef <= 10 ? scrollRef++ : AOS.refresh();
  });


$(document).ready(function () {

    
    // Enable AoS animations
    AOS.init({
        duration:1000,
        offset:5,
        delay:10,
    });


     //Splash Screen
    if (sessionStorage.getItem('session-active') !== 'true') { 
        // set to true for one time show. 
        sessionStorage.setItem('session-active','true');
        $('.splash-screen').show();
        $('body').addClass('animate-in');
        setTimeout( function(){
                 $('.splash-logo').toggleClass('fade-toggle');
        },1500);
        $('.splash-screen').fadeIn(500, function(){
            setTimeout(function(){ 
                //Fade out splash - add classes to animate X positions of elements on home
                $('.splash-screen').fadeOut(1000);
                $('.header-bar, .image-rotator-content .content-align, .image-rotator-content .rotator-logo').addClass('animate-in');
            }, 3000);
        });
    } else {
        $('.splash-screen').hide();
        $('.header-bar, .image-rotator-content .content-align, .image-rotator-content .rotator-logo').addClass('no-animate');
    }


    // HEADER HIDE AND SHOW ON SCROLL
    var header = document.querySelector(".header-bar");
    var main = document.querySelector(".page-wrapper");
    var headerHeight = document.querySelector(".header-bar").offsetHeight;
    main.style.top = headerHeight + "px";
    let lastScroll = 0;
    window.addEventListener("scroll", () => {
      let currentScroll = window.pageYOffset;
      if (currentScroll - lastScroll > 0) {
        header.classList.add("scroll-down");
        header.classList.remove("scroll-up");
      } else {
        // scrolled up -- header show
        header.classList.add("scroll-up");
        header.classList.remove("scroll-down");
      }
      lastScroll = currentScroll;
    })


    //Home Rotator section scroll
    $('#home-intro-scroll').on('click', function(){
        $('html,body').animate({
            scrollTop: $("#home-intro-text").offset().top
        }, 1000);
    });

    //About page - logo text block scroll
    $('#team-block-scroll').on('click', function(){
        $('html,body').animate({
            scrollTop: $("#team-block").offset().top
        }, 1000);
    });

    //Services page - logo text block scroll - scroll to info block on desktop / main process block on mobile (info block hidden on mob)
    if ($(window).width() >= 768) {
        $('#process-info-scroll').on('click', function(){
            $('html,body').animate({
                scrollTop: $("#process-info-block").offset().top
            }, 1000);
        });
    } else {
        $('#process-info-scroll').on('click', function(){
            $('html,body').animate({
                scrollTop: $("#mob-process-block").offset().top
            }, 1000);
        });
    }

     //Testimonials page - logo text block scroll
    $('#testimonial-block-scroll').on('click', function(){
        $('html,body').animate({
            scrollTop: $("#testimonials-wrap").offset().top - 160
        }, 1000);
    });

    // Process text block - read more
    $('.process-block .read-more').on('click', function(){
        $(this).toggleText('Read more', 'Read less');
        $(this).prev().toggle();
    });


    // Logo text block - read more
    $('.logo-text-block .read-more').on('click', function(){
        $(this).toggleText('Read more', 'Read less');
        $(this).prev().toggle();
    });


    //Mobile Menu
    $('.mobile-menu-toggle').click(function () {
        $(this).toggleClass('active');
        $(this).toggleText('Menu', 'Close');
        $('.mobile-menu').slideToggle(600);
        $('body').toggleClass('menu-open');
    });


    // Mobile main menu toggle
    $('.mobile-menu-toggle').off('click').on('click', function(e) {
        // Prevent default link action and stop the click from bubbling up to parent elements
        e.preventDefault();
        e.stopPropagation();

        var $mobileMenu = $('.mobile-menu');
        
        // Toggle the menu slide
        $mobileMenu.stop(true, true).slideToggle(300);

        // Toggle 'Close' and 'Menu' text safely
        var currentText = $(this).text().trim();
        if (currentText === 'Menu') {
            $(this).text('Close');
        } else {
            $(this).text('Menu');
        }
    });

    // Prevent clicks inside the open mobile menu from closing it
    $('.mobile-menu').on('click', function(e) {
        e.stopPropagation();
    });


    $('.mobile-only .main-nav .menu-item-has-children').each(function() {
        if ($(this).hasClass('current-menu-parent') || $(this).hasClass('current-page-ancestor')) {
            $(this).addClass('sub-open');
            $(this).children('.sub-menu').show(); // Force show without animation on load
        }
    });

    // Toggle sub-menu on click
    $('.mobile-only .main-nav .menu-item-has-children > a')
    .off('click')
    .on('click', function(e) {
        e.preventDefault();

        const $parent = $(this).parent();
        const $submenu = $parent.children('.sub-menu');

        if ($parent.hasClass('sub-open')) {
            $parent.removeClass('sub-open');
            $submenu.stop(true, true).slideUp(250);
        } else {
            $parent.addClass('sub-open');
            $submenu.stop(true, true).slideDown(250);
        }
    });




    // Mobile function for dynamic read more / ress less functionality based on word count.
    if ($(window).width() < 1024) {
        $('.mob-read-more').each(function () {
            var words = $(this)
                .text()
                .replace('.')
                .replace(',')
                .split(' ')
                .filter(function (a) {
                return a
            });

            var maxWords = 35;
            var shortStr = words.slice(0, maxWords).join(' ');;
            var longStr = words.slice(maxWords, words.length).join(' ')
            if (words.length > maxWords) {
            var html =
                  shortStr +
                  '<span class="more_text" style="display:none;"> ' +
                  longStr +
                  '</span>' +
                  '<a class="read-more"> Read more</a>';

                $(this).html(html);

                $(this)
                  .find('a.read-more')
                  .click(function (event) {
                    $(this).toggleClass('less')
                    event.preventDefault()
                    if ($(this).hasClass('less')) {
                      $(this).html(' Read less')
                      $(this).parent().find('.more_text').show()
                    } else {
                      $(this).html(' Read more')
                      $(this).parent().find('.more_text').hide()
                    }
                  });
              }
        });
    }


    // BACK TO TOP 
    $('.back-to-top').on('click', function(){
        $('html,body').animate({
            scrollTop: 0
        }, 1000);
    });


    // BACK TO TOP - fade out in top section of height of window.
    if ($(window).width() > 1023) {
	    window.addEventListener("scroll", function() {
		    var sectionHeight = $(window).height() - 400;
		     if ($(window). scrollTop() < 200) {
		        $('.back-to-top').removeClass('show');
		    } else {
		    	$('.back-to-top').addClass('show');
		    }
		});
	}
   
    
   	// HOME SLIDER
    var slider = $('.image-rotator').bxSlider({
        mode:'fade',
        auto: true,
        pagerCustom: '.bx-pager',
        controls:true,
        infiniteLoop: true,
        speed:1000,
        pause:5000,
        touchEnabled:false,
        onSlideBefore: function(currentSlideNumber, totalSlideQty, currentSlideHtmlObject) {
            var progressLength = (currentSlideHtmlObject +1) * 33.33333+ '%';
            $('.progress span').css('max-width',progressLength);
            $('.slide-number').text((slider.getCurrentSlide()+1)+'  of  '+ slider.getSlideCount());  
        }
    });


    // NEWSLETTER FILTER
    let currentYear = 'all';
    let currentSort = 'newest';
    const filters = document.querySelectorAll('.year-filter li');
    const sortButtons = document.querySelectorAll('.newsletter-sort li');

    function updateNewsletters() {
        const cards = [...document.querySelectorAll('.newsletter-card')];
        const grid = document.querySelector('.newsletter-list');
        let visibleCards = cards.filter(card => {
            return currentYear === 'all' || card.dataset.year === currentYear;
        });


        visibleCards.sort((a, b) => {
            const yearA = Number(a.dataset.year);
            const yearB = Number(b.dataset.year);
            const quarterA = Number(a.dataset.quarter);
            const quarterB = Number(b.dataset.quarter);

            if (currentSort === 'newest') {
                return yearB - yearA || quarterB - quarterA;
            }

            return yearA - yearB || quarterA - quarterB;

        });


        // Hide all
        cards.forEach(card => {
            card.style.display = 'none';
        });


        // Re-add sorted visible cards
        visibleCards.forEach(card => {
            card.style.display = '';
            grid.appendChild(card);
        });

    }


    // Year filter
    filters.forEach(filter => {
        filter.addEventListener('click', function() {
            currentYear = this.id;
            filters.forEach(item => {
                item.classList.remove('active');
            });
            this.classList.add('active');
            updateNewsletters();
        });
    });


    // Sorting
    sortButtons.forEach(button => {
        button.addEventListener('click', function() {
            currentSort = this.id;
            sortButtons.forEach(item => {
                item.classList.remove('active');
            });
            this.classList.add('active');
            updateNewsletters();
        });
    });

    // Initial load
    updateNewsletters();





    // CONTACT FORM TEXTAREA AUTO GROW
    $("textarea").keyup(function(e) {
        while($(this).outerHeight() < this.scrollHeight + parseFloat($(this).css("borderTopWidth")) + parseFloat($(this).css("borderBottomWidth"))) {
            $(this).height($(this).height()+1);
        };
    });

     // HIDE CF7 FORM ON SEND
    if ($('.wpcf7').length) {
        var wpcf7Elm = document.querySelector( '.wpcf7' );

        wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {
          $('.form-wrap').hide();
        }, false );
    }

});


// WEBPACK FOOTER //
// ./assets/js/main.js